<template>
  <div>
    <!-- Exportar Excel -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="excelDialog"
      max-width="500px"
    >
      <ExcelModal
        title="Exportar Pedidos"
        textMessage="Deseja exportar os pedidos para excel ?"
        cancelBtn="Cancelar"
        okbtn="Sim, exportar"
        icone="mdi-arrow-up-circle"
        textObservation=""
        @close="excelDialog = false"
        @generate="(excelDialog = false), generateExcel()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <HeaderOrders
      :arrow="false"
      title="Pedidos"
      text="Gerencie seus pedidos em uma lista completa, visualizando os status, detalhamento e um históricos de pedidos antigos."
      :haveAction="true"
      actionTitle="Novo Pedido"
    />

    <v-container
      style="max-width: unset; background: #e5e5e5"
      class="pa-4 pt-2 ma-0"
    >
      <v-row
        class="pa-0 ma-0"
        style="display: flex; justify-content: space-evenly"
      >
        <v-col cols="12" md="3" sm="6">
          <v-card elevation="3" class="card pa-4 ma-0">
            <div class="card-container">
              <div class="card-title">{{ this.realizados }}</div>
              Pedidos realizados
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="3" sm="6">
          <v-card elevation="3" class="card pa-4 ma-0">
            <div class="card-container">
              <div class="card-title" style="color: #8dc63f">
                {{ this.finalizados }}
              </div>
              Pedidos finalizados
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="3" sm="6">
          <v-card elevation="3" class="card pa-4 ma-0">
            <div class="card-container">
              <div class="card-title" style="color: #e30011">
                {{ this.cancelados }}
              </div>
              Pedidos cancelados
            </div>
          </v-card>
        </v-col>

        <v-col
          style="
            justify-content: center;
            align-self: center;
            text-align-last: center;
          "
          cols="12"
          md="3"
          sm="6"
        >
          <v-dialog
            ref="dates"
            v-model="dates"
            :return-value.sync="datesOrders"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="calendry" v-bind="attrs" v-on="on">
                <div style="font-size: 22px; align-self: center">
                  {{ !datesOrders[0] ? "Data" : formatDay(datesOrders[0]) }}
                  -
                  {{ !datesOrders[1] ? "" : formatDay(datesOrders[1]) }}
                </div>
                <v-icon large>mdi-calendar-blank-outline</v-icon>
              </div>
            </template>

            <v-date-picker
              v-model="datesOrders"
              scrollable
              range
              locale="pt-br"
            >
              <v-btn text color="primary" @click="dates = false">
                Cancelar</v-btn
              >
              <v-btn
                text
                color="primary"
                :disabled="datesOrders.length < 2"
                @click="filterDates(datesOrders)"
              >
                OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>

      <br />
      <v-tabs
        v-model="activeTab"
        class="px-0"
        background-color="#ECEEF1"
        grow
        height="55"
        hide-slider
      >
        <v-tab
         :value="0"
          active-class="active-tab"
          class="tab"
          style="font-weight: bold !important"
          @click="activeTab = 0"
        >
          <span>Pedidos em aberto</span>
        </v-tab>

        <v-tab
          :value="1"
          active-class="active-tab"
          class="tab"
          @click="activeTab = 1"
        >
          <span>Histórico de Pedidos</span>
        </v-tab>
      </v-tabs>

      <v-card
        v-if="activeTab === 0"
        transition="scale-transition"
        class="d-column mt-0 mb-4 py-1"
        elevation="1"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <v-row class="pt-3 pb-2 ma-0">
          <v-row cols="12" class="ma-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Nome do cliente"
                  label="Nome do cliente"
                  v-model="filterPedidosEmAbertos.clientName"
                  attach
                  class="primary-input"
                  dense
                  clearable
              >
                <template v-slot:append>
                  <v-icon class="pt-0" color="normalred" size="26">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="E-mail do cliente"
                  label="E-mail do cliente"
                  v-model="filterPedidosEmAbertos.clientEmail"
                  attach
                  class="primary-input"
                  dense
                  clearable
              >
                <template v-slot:append>
                  <v-icon class="pt-0" color="normalred" size="26">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Telefone do cliente"
                  label="Telefone do cliente"
                  v-model="filterPedidosEmAbertos.clientPhone"
                  attach
                  v-mask="'(##) #####-####'"
                  class="primary-input"
                  dense
                  clearable
              >
                <template v-slot:append>
                  <v-icon class="pt-0" color="normalred" size="26">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row cols="12" class="ma-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="CPF/CNPJ do cliente"
                  label="CPF/CNPJ do cliente"
                  v-model="filterPedidosEmAbertos.clientCpfCnpj"
                  attach
                  class="primary-input"
                  v-mask="(filterPedidosEmAbertos.clientCpfCnpj && filterPedidosEmAbertos.clientCpfCnpj.length <= 14) ? '###.###.###-##' : '##.###.###/####-##'"
                  dense
              >
                <template v-slot:append>
                  <v-icon class="pt-0" color="normalred" size="26">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Nome do produto"
                  label="Nome do produto"
                  v-model="filterPedidosEmAbertos.productName"
                  attach
                  class="primary-input"
                  dense
                  clearable
              >
                <template v-slot:append>
                  <v-icon class="pt-0" color="normalred" size="26">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Número do pedido"
                  label="Número do pedido"
                  v-model="filterPedidosEmAbertos.orderCode"
                  attach
                  class="primary-input"
                  dense
                  clearable
              >
                <template v-slot:append>
                  <v-icon class="pt-0" color="normalred" size="26">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row justify="end" cols="12" class="ma-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-select
                  v-model="orderStatusPedidosEmAberto"
                  :items="statusPedidoEmAberto"
                  item-text="label"
                  item-value="value"
                  outlined
                  append-icon="mdi-chevron-down"
                  hide-details
                  class="primary-input"
                  dense
                  full-width
                  placeholder="status"
                  @change="filterSelectOpenOrders()"
              ></v-select>
            </v-col>

            <v-col class="d-flex justify-end" cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <v-btn
                  elevation="0"
                  class="primary-button mr-2"
                  outlined
                  style="height: 40px!important;"
                  @click="filterOpenOrders()"
              >
                <span style="font-size: 16px">Pesquisar</span>
              </v-btn>
              <v-btn
                  elevation="0"
                  class="terciary-button"
                  outlined
                  style="height: 40px!important;"
                  @click="clearFilter()"
              >
                <span style="font-size: 16px">Limpar filtros</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-row>
      </v-card>

      <v-card
        v-if="activeTab === 1"
        transition="scale-transition"
        class="d-column mt-0 mb-4 py-1"
        elevation="1"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                outlined
                hide-details
                placeholder="Nome do cliente"
                label="Nome do cliente"
                v-model="filterPedidosEmHistorico.clientName"
                attach
                class="primary-input"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                outlined
                hide-details
                placeholder="E-mail do cliente"
                label="E-mail do cliente"
                v-model="filterPedidosEmHistorico.clientEmail"
                attach
                class="primary-input"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                outlined
                hide-details
                placeholder="Telefone do cliente"
                label="Telefone do cliente"
                v-model="filterPedidosEmHistorico.clientPhone"
                attach
                v-mask="'(##) #####-####'"
                class="primary-input"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                outlined
                hide-details
                placeholder="CPF/CNPJ do cliente"
                label="CPF/CNPJ do cliente"
                v-model="filterPedidosEmHistorico.clientCpfCnpj"
                attach
                class="primary-input"
                v-mask="(filterPedidosEmHistorico.clientCpfCnpj && filterPedidosEmHistorico.clientCpfCnpj.length <= 14) ? '###.###.###-##' : '##.###.###/####-##'"
                dense
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                outlined
                hide-details
                placeholder="Nome do produto"
                label="Nome do produto"
                v-model="filterPedidosEmHistorico.productName"
                attach
                class="primary-input"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                outlined
                hide-details
                placeholder="Número do pedido"
                label="Número do pedido"
                v-model="filterPedidosEmHistorico.orderCode"
                attach
                class="primary-input"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row justify="end" cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-select
                v-model="orderStatusPedidosEmHistorico"
                :items="statusPedidoEmHistorico"
                item-text="label"
                item-value="value"
                outlined
                append-icon="mdi-chevron-down"
                hide-details
                required
                placeholder="status"
                @change="filterSelectOrderHistory()"
                dense
                full-width
                class="primary-input"
            ></v-select>
          </v-col>

          <v-col class="d-flex justify-end" cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-btn
                elevation="0"
                class="primary-button mr-2"
                outlined
                style="height: 40px!important;"
                @click="filterOrderHistory()"
            >
              <span style="font-size: 16px">Pesquisar</span>
            </v-btn>
            <v-btn
                elevation="0"
                class="terciary-button"
                outlined
                style="height: 40px!important;"
                @click="clearFilter()"
            >
              <span style="font-size: 16px">Limpar filtros</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-tabs-items v-model="activeTab">
        <v-tab-item :value="0">
          <!-- Tabela1 -->
          <v-data-table
            ref="table"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum pedido encontrado"
            :headers="headers"
            :items="ordersActive"
            class="elevation-3 mytable content-table"
            style="cursor: pointer"
            hide-default-footer
            :items-per-page="pageSizePedidosEmAbertos"
            :header-props="headerProps"
            @click:row="handleRowClick"
            :key="componentKey"
          >
            <template v-slot:[`header.download`]="{ header }">
              <v-btn
                outlined
                tile
                icon
                v-on="header"
                class="quinary-button"
                style="border-radius: 5px"
                @click="exportOpenOrdersExcel"
              >
                <v-icon>mdi-download-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.orderCode`]="{ item }">
              <span v-if="item.orderStatus === 0" :class="item.orderStatus === 0 ? 'novo-bold' : 'normal'">
                {{ item.orderCode }}
              </span>
              <strong v-else :style="item.orderStatus === 11 ? 'color: orange' : ''">
                {{ item.orderCode }}
              </strong>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              <span v-if="item.orderStatus === 0" :class="item.orderStatus == 0 ? 'novo-bold' : 'normal'">
                {{ formatDate(item.created_at) }}
              </span>
              <strong v-else :style="item.orderStatus === 11 ? 'color: orange' : ''">
                {{ formatDate(item.created_at) }}
              </strong>
            </template>

            <template v-slot:[`item.client.name`]="{ item }">
              <span v-if="item.orderStatus === 0" :class="item.orderStatus == 0 ? 'novo-bold' : 'normal'">
                {{ item.client.name }}
              </span>
              <strong v-else :style="item.orderStatus === 11 ? 'color: orange' : ''">
                {{ item.client.name }}
              </strong>
            </template>

            <template v-slot:[`item.totalPrice`]="{ item }">
              <span  v-if="item.orderStatus === 0" :class="item.orderStatus == 0 ? 'novo-bold' : 'normal'">
                {{
                  (item.fretePrice + item.totalPrice + item.installmentsInterest).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
              <strong v-else :style="item.orderStatus === 11 ? 'color: orange' : ''">
                {{
                  (item.fretePrice + item.totalPrice + item.installmentsInterest).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </strong>
            </template>

            <template v-slot:[`item.resaleName`]="{ item }">
              <span v-if="item.orderStatus === 0"  :class="item.orderStatus == 0 ? 'novo-bold' : 'normal'">
                {{ item.resale.nameFantasy }}
              </span>
              <strong v-else :style="item.orderStatus === 11 ? 'color: orange' : ''">
                {{ item.resale.nameFantasy }}
              </strong>
            </template>

            <template v-slot:[`item.orderStatus`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    style="border-radius: 12px; width: fit-content!important;"
                    :class="
                      item.orderStatus === 0
                        ? 'novo'
                        : item.orderStatus === 1
                        ? 'aguardando'
                        : item.orderStatus === 3 ||
                          item.orderStatus === 6 ||
                          item.orderStatus === 10
                        ? 'enviado'
                        : item.orderStatus === 4 || item.orderStatus === 9
                        ? 'enviado'
                        : item.orderStatus === 7 ||
                          item.orderStatus === 5 ||
                          item.orderStatus === 2 ||
                          item.orderStatus === 11
                        ? 'devolvido'
                        : 'entregue'
                    "
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon style="font-size: 15px">
                      {{
                        status1.find((x) => x.value === item.orderStatus).label
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{
                  status1.find((x) => x.value === item.orderStatus).label
                }}</span>
              </v-tooltip>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItemsPedidosEmAbertos > pageSizePedidosEmAbertos"
                    :currentPage="currentPagePedidosEmAbertos"
                    :totalItems="totalItemsPedidosEmAbertos"
                    :page="pagePedidosEmAbertos"
                    :pageSize="pageSizePedidosEmAbertos"
                    :totalPages="totalPagesPedidosEmAbertos"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item :value="1">
          <!-- Tabela2-->
          <v-data-table
            ref="table"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum pedido encontrado"
            :headers="headers2"
            :items="ordersHistoric"
            class="elevation-3 mytable content-table"
            hide-default-footer
            :items-per-page="pageSizePedidosEmHistorico"
            :header-props="headerProps"
            @click:row="handleRowClick"
            :key="componentKey"
          >
            <template v-slot:[`header.download`]="{ header }">
              <v-btn
                outlined
                tile
                icon
                v-on="header"
                class="quinary-button"
                style="border-radius: 5px"
                @click="exportExcel"
              >
                <v-icon>mdi-download-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDate(item.created_at) }}
            </template>

            <template v-slot:[`item.totalPrice`]="{ item }">
              {{
                (item.fretePrice + item.totalPrice + item.installmentsInterest).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>

            <template v-slot:[`item.orderStatus`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    :class="
                      item.orderStatus === 0
                        ? 'novo'
                        : item.orderStatus === 1
                        ? 'aguardando'
                        : item.orderStatus === 3 ||
                          item.orderStatus === 6 ||
                          item.orderStatus === 10
                        ? 'aprovado'
                        : item.orderStatus === 4 || item.orderStatus === 9
                        ? 'enviado'
                        : item.orderStatus === 7 ||
                          item.orderStatus === 5 ||
                          item.orderStatus === 2
                        ? 'devolvido'
                        : 'entregue'
                    "
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon style="font-size: 15px">
                      {{
                        status1.find((x) => x.value === item.orderStatus).label
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{
                  status1.find((x) => x.value === item.orderStatus).label
                }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.finalizacao`]="{ item }">
              {{
                item.orderStatusList && item.orderStatusList.length > 0
                  ? formatDate(
                      item.orderStatusList[item.orderStatusList.length - 1]
                        .created_at
                    )
                  : "-"
              }}
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItemsPedidosEmHistorico > pageSizePedidosEmHistorico"
                    :currentPage="currentPagePedidosEmHistorico"
                    :totalItems="totalItemsPedidosEmHistorico"
                    :page="pagePedidosEmHistorico"
                    :pageSize="pageSizePedidosEmHistorico"
                    :totalPages="totalPagesPedidosEmHistorico"
                    @back-page="backPagePedidosEmHistorico"
                    @next-page="nextPagePedidosEmHistorico"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<style scoped>
.novo-bold {
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  letter-spacing: 0.15px !important;
  color: #000000 !important;
}

.normal {
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  letter-spacing: 0.15px !important;
  color: #9c9c9c !important;
}

.novo {
  width: 100px !important;
  height: 30px !important;
  background: #979797 !important;
  border-radius: 10px !important;
  color: white !important;
  font-style: normal;
  font-weight: 500;
  font-size: 151px !important;
}

.aguardando {
  width: 100px !important;
  height: 30px !important;
  color: orange !important;
  border: 1px solid orange !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.aprovado {
  width: 100px !important;
  height: 30px !important;
  color: #fee853 !important;
  border: 1px solid #fee853;
  box-sizing: border-box !important;
  border-radius: 10px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 3px !important;
}

.entregue {
  width: 100px !important;
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.enviado {
  width: 100px !important;
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.devolvido {
  width: 100px !important;
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.cancelado {
  width: 100px !important;
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 14px !important;
}

.calendry {
  display: inline-flex;
  text-align-last: center;
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 37px;

  letter-spacing: 0.15px;

  color: #494949;
}

.card-container {
  text-align-last: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;

  letter-spacing: 0.15px;

  color: #979797;
}

.card-title {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 35px;
  line-height: 52px;

  letter-spacing: 0.15px;

  color: #494949;
}

.card {
  background: #ffffff;
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);
  border-radius: 6px;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.table-button {
  width: 150px !important;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 52.69%;

  letter-spacing: 0.15px;
  font-weight: bold !important;
  transition: 300ms !important;
}

.table-button:hover {
  background: #2d3038 !important;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 1024px) {
  .mytable {
    max-width: 100%;
  }
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import ExcelModal from "../components/ExcelModal.vue";
import HeaderOrders from "./components/HeaderOrders.vue";
import router from "../../../router";
import Vue from "vue";
import moment from "moment";
import { throwStatement } from "@babel/types";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    Pagination,
    HeaderOrders,
    ExcelModal,
  },

  data: () => ({
    datesOrders: [],
    datesOrderHistory: [],
    dates: false,
    dateModalOrderHistory: false,
    realizados: 0,
    finalizados: 0,
    cancelados: 0,
    componentKey: 1,
    orderStatusPedidosEmAberto: null,
    orderStatusPedidosEmHistorico: null,
    name: "",
    statusPedidoEmAberto: [
      { label: "Aguardando", value: 1 },
      { label: "Aprovado", value: 3 },
      { label: "Separando", value: 6 },
      { label: "Etiqueta", value: 10 },
      { label: "Enviado", value: 4 },
      { label: "Cancelado parcialmente", value: 11 },
    ],
    statusPedidoEmHistorico: [
      { label: "Reprovado", value: 2 },
      { label: "Entregue", value: 8 },
      { label: "Devolvido", value: 5 },
      { label: "Cancelado", value: 7 },
    ],
    status1: [
      { label: "Aguardando", value: 1 },
      { label: "Reprovado", value: 2 },
      { label: "Aprovado", value: 3 },
      { label: "Separando", value: 6 },
      { label: "Etiqueta", value: 10 },
      { label: "Cancelado parcialmente", value: 11 },
      { label: "Enviado", value: 4 },
      { label: "Entregue", value: 8 },
      { label: "Cancelado", value: 7 },
      { label: "Retirar", value: 9 },
      { label: "Devolvido", value: 5 },
    ],
    status2: [
      { label: "Reprovado", value: 2 },
      { label: "Entregue", value: 8 },
      { label: "Devolvido", value: 5 },
      { label: "Cancelado", value: 7 },
    ],
    orders: [],
    statusPedidoEmAbertos: [1, 3, 6, 10, 4, 9, 11],
    statusPedidoHistorico: [2, 8, 5, 7],
    mesesAnos: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "out",
      "Nov",
      "Dez",
    ],
    ordersActive: [],
    ordersHistoric: [],
    categories: [1, 2, 3],
    ocurrentOrder: [],
    changeDialog: false,
    closeNoLoading: false,
    dialogKey: false,
    excelDialog: false,
    currentUser: null,
    loading: false,
    activeTab: 0,
    apiService: new ApiService(),
    pagePedidosEmAbertos: 1,
    totalPagesPedidosEmAbertos: 1,
    pageSizePedidosEmAbertos: 10,
    totalItemsPedidosEmAbertos: 1,
    currentPagePedidosEmAbertos: 1,

    pagePedidosEmHistorico: 1,
    totalPagesPedidosEmHistorico: 1,
    pageSizePedidosEmHistorico: 10,
    totalItemsPedidosEmHistorico: 1,
    currentPagePedidosEmHistorico: 1,
    filterExportOrders: [],
    sizes: [10, 20, 40, 120],
    filterPedidosEmHistorico: {
      page: 1,
      pageSize: 10,
      OrderStatus: [],
      orderCode: null,
      cpfCnpj: null,
      clientName: null,
      clientEmail: null,
      clientPhone: null,
      clientCpfCnpj: null,
    },
    filterPedidosEmAbertos: {
      page: 1,
      pageSize: 10,
      OrderStatus: [],
      orderCode: null,
      cpfCnpj: null,
      clientName: null,
      clientEmail: null,
      clientPhone: null,
      clientCpfCnpj: null,
    },
    filterOrdersPlaced: {
      resaleId: null,
    },
    headers: [
      {
        text: "Pedido",
        align: "start",
        class: "item",
        value: "orderCode",
        sortable: false,
      },
      {
        text: "Data de compra",
        class: "item",
        value: "created_at",
        align: "start",
        sortable: false,
      },
      {
        text: "Cliente",
        class: "item",
        value: "client.name",
        align: "start",
        sortable: false,
      },
      {
        text: "Total",
        class: "item",
        value: "totalPrice",
        align: "start",
        sortable: false,
      },
      {
        text: "Revendedor",
        class: "item",
        value: "resale.nameFantasy",
        align: "start",
        sortable: false,
      },
      {
        text: "Status",
        class: "item",
        value: "orderStatus",
        align: "center",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headers2: [
      {
        text: "Pedido",
        align: "start",
        class: "item",
        value: "orderCode",

        sortable: false,
      },
      {
        text: "Data de compra",
        class: "item",
        value: "created_at",
        align: "start",
        sortable: false,
      },
      {
        text: "Cliente",
        class: "item",
        value: "client.name",
        align: "start",
        sortable: false,
      },
      {
        text: "Total",
        class: "item",
        value: "totalPrice",
        align: "start",
        sortable: false,
      },
      {
        text: "Revendedor",
        class: "item",
        value: "resale.nameFantasy",
        align: "start",
        sortable: false,
      },
      {
        text: "Status",
        class: "item",
        value: "orderStatus",
        align: "center",
        sortable: false,
      },
      {
        text: "Data da finalização",
        align: "start",
        sortable: false,
        value: "finalizacao",
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
  }),

  async created() {
    this.currentUser = JSON.parse(localStorage.getItem("user"));
    /*const hoje = new Date();
    const dateFim = new Date();
    hoje.setMonth(hoje.getMonth() - 3);
    dateFim.setDate(hoje.getDate() + 2);
    this.datesOrders = [Utils.nowFormat(hoje), Utils.nowFormat(dateFim)];*/
    await this.initFilterOrderHistory();
    await this.initFilterOpenOrders();

    const jsonFilters = JSON.parse(localStorage.getItem("ordersResaleFilters"));

    if (jsonFilters) {
      this.filterPedidosEmHistorico = jsonFilters.filterPedidosEmHistorico
          ? jsonFilters.filterPedidosEmHistorico
          : this.filterPedidosEmHistorico;

      this.orderStatusPedidosEmHistorico = this.filterPedidosEmHistorico.OrderStatus.length === 1 ? this.filterPedidosEmHistorico.OrderStatus[0] : null

      this.filterOrdersPlaced = jsonFilters.filterOrdersPlaced
          ? jsonFilters.filterOrdersPlaced
          : this.filterOrdersPlaced;

      this.filterPedidosEmAbertos = jsonFilters.filterPedidosEmAbertos
          ? jsonFilters.filterPedidosEmAbertos
          : this.filterPedidosEmAbertos;

      this.orderStatusPedidosEmAberto = this.filterPedidosEmAbertos.OrderStatus.length === 1 ? this.filterPedidosEmAbertos.OrderStatus[0] : null

      this.datesOrders = [this.filterPedidosEmAbertos.dateStart, this.filterPedidosEmAbertos.dateEnd];

      this.pagePedidosEmAbertos = jsonFilters.pagePedidosEmAbertos
          ? jsonFilters.pagePedidosEmAbertos
          : this.pagePedidosEmAbertos;

      this.pagePedidosEmHistorico = jsonFilters.pagePedidosEmHistorico
          ? jsonFilters.pagePedidosEmHistorico
          : this.pagePedidosEmHistorico;


      await this.pedidosEmAbertos();
      await this.pedidosEmHistorico();
      const activeTab = localStorage.getItem("ordersResaleFiltersTab");
      this.activeTab = activeTab ? Number(activeTab) : 0;
    }
    await this.ordersPlaced();
  },

  methods: {
    async ordersPlaced() {
      this.filterOrdersPlaced.resaleId = this.currentUser.id;
      await this.apiService
        .post(`order/orders-placed`, this.filterOrdersPlaced)
        .then((ordersPlaced) => {
          this.cancelados = ordersPlaced.numberOrdersCanceled;
          this.finalizados = ordersPlaced.numberOrdersFinished;
          this.realizados = ordersPlaced.numberOrdersPlaced;
        });
    },

    async filterOrderHistory() {
      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.filterPedidosEmHistorico.page = 1;
      this.pagePedidosEmHistorico = 1;
      await this.pedidosEmHistorico();
    },

    async filterSelectOrderHistory() {
      const status = [];
      status.push(this.orderStatusPedidosEmHistorico);
      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.filterPedidosEmHistorico.OrderStatus = status;
      this.filterPedidosEmHistorico.page = 1;
      this.pagePedidosEmHistorico = 1;
      await this.pedidosEmHistorico();
    },

    async filterDates(dates) {
      this.$refs.dates.save(dates);
      let [start, end] = dates;

      if (moment(start).isAfter(moment(end))) {
        const startD = start;
        const endD = end;
        start = endD;
        end = startD;
        this.$refs.dates.save([start, end]);
      }

      this.filterPedidosEmAbertos.resaleId = this.currentUser.id;
      this.filterPedidosEmAbertos.page = 1;
      this.filterPedidosEmHistorico.page = 1;

      this.filterPedidosEmAbertos.resaleId = this.currentUser.id;
      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.filterPedidosEmAbertos.dateStart = start;
      this.filterPedidosEmAbertos.dateEnd = end;
      this.filterPedidosEmHistorico.dateStart = start;
      this.filterPedidosEmHistorico.dateEnd = end;
      this.dates = false;
      await this.pedidosEmAbertos();
      await this.pedidosEmHistorico();
      /*if (this.activeTab === 0) {
        await this.pedidosEmAbertos();
      } else {
        await this.pedidosEmHistorico();
      }*/
    },

    async filterOpenOrders() {
      this.filterPedidosEmAbertos.resaleId = this.currentUser.id;
      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.filterPedidosEmAbertos.page = 1;
      this.pagePedidosEmAbertos = 1;
      await this.pedidosEmAbertos();
    },

    async filterSelectOpenOrders() {
      const status = [];
      status.push(this.orderStatusPedidosEmAberto);
      this.filterPedidosEmAbertos.resaleId = this.currentUser.id;
      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.filterPedidosEmAbertos.OrderStatus = status;
      this.filterPedidosEmAbertos.page = 1;
      this.pagePedidosEmAbertos = 1;
      await this.pedidosEmAbertos();
    },

    async clearFilterOpenOrders() {
      this.datesOrders = [];
      localStorage.setItem("ordersResaleFilters", null);
      localStorage.setItem("ordersResaleFiltersTab", null);
      await this.initFilterOpenOrders()
    },

    async initFilterOpenOrders() {
      /*const hoje = new Date();
      const dateFim = new Date();
      hoje.setMonth(hoje.getMonth() - 3);
      this.datesOrders = [Utils.nowFormat(hoje), Utils.nowFormat(dateFim)];*/
      const [start, end] = this.datesOrders;

      this.filterPedidosEmAbertos.resaleId = this.currentUser.id;
      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.orderStatusPedidosEmAberto = "";
      this.filterPedidosEmAbertos = {
        page: 1,
        pageSize: 10,
        orderCode: null,
        dateStart: start,
        dateEnd: end,
        OrderStatus: this.statusPedidoEmAbertos,
        clientName: null,
        clientEmail: null,
        clientPhone: null,
        clientCpfCnpj: null,
      };
      this.pagePedidosEmAbertos = 1
      await this.pedidosEmAbertos();
    },

    async pedidosEmAbertos() {
      try {
        this.loading = true;

        this.filterOrdersPlaced = this.filterPedidosEmAbertos;
        this.filterPedidosEmAbertos.resaleId = this.currentUser.id;
        await this.apiService
          .post(`order/list`, this.filterPedidosEmAbertos)
          .then(async (response) => {
            this.ordersActive = response.orders;
            this.totalPagesPedidosEmAbertos = response.pager.totalPages;
            this.totalItemsPedidosEmAbertos = response.pager.totalItems;
            this.currentPagePedidosEmAbertos = response.pager.currentPage;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } catch (e) {
        this.loading = false;
      }
    },

    async backPage() {
      this.filterPedidosEmAbertos.page -= 1;
      this.pagePedidosEmAbertos = this.filterPedidosEmAbertos.page;
      await this.pedidosEmAbertos();
    },

    async nextPage() {
      this.filterPedidosEmAbertos.page += 1;
      this.pagePedidosEmAbertos = this.filterPedidosEmAbertos.page;
      await this.pedidosEmAbertos();
    },


    async clearFilterOrderHistory() {
      this.datesOrders = [];
      localStorage.setItem("ordersResaleFilters", null);
      localStorage.setItem("ordersResaleFiltersTab", null);
      await this.initFilterOrderHistory()
    },

    async clearFilter() {
      this.datesOrders = [];
      localStorage.setItem("ordersResaleFilters", null);
      localStorage.setItem("ordersResaleFiltersTab", null);
      await this.initFilterOrderHistory()
      await this.initFilterOpenOrders()
    },

    async initFilterOrderHistory() {
      /*const hoje = new Date();
      const dateFim = new Date();
      hoje.setMonth(hoje.getMonth() - 3);
      this.datesOrders = [Utils.nowFormat(hoje), Utils.nowFormat(dateFim)];*/
      const [start, end] = this.datesOrders;

      this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
      this.orderStatusPedidosEmHistorico = "";

      this.filterPedidosEmHistorico = {
        page: 1,
        pageSize: 10,
        orderCode: null,
        dateStart: start,
        dateEnd: end,
        OrderStatus: this.statusPedidoHistorico,
        clientName: null,
        clientEmail: null,
        clientPhone: null,
        clientCpfCnpj: null,
      };
      this.pagePedidosEmHistorico = 1
      await this.pedidosEmHistorico();
    },

    async pedidosEmHistorico() {
      try {
        this.loading = true;
        this.filterPedidosEmHistorico.resaleId = this.currentUser.id;
        await this.apiService
          .post(`order/list`, this.filterPedidosEmHistorico)
          .then((response) => {
            this.loading = false;
            this.ordersHistoric = response.orders;
            this.totalPagesPedidosEmHistorico = response.pager.totalPages;
            this.totalItemsPedidosEmHistorico = response.pager.totalItems;
            this.currentPagePedidosEmHistorico = response.pager.currentPage;
            this.filterOrdersPlaced = this.filterPedidosEmHistorico;
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    async backPagePedidosEmHistorico() {
      this.filterPedidosEmHistorico.page -= 1;
      this.pagePedidosEmHistorico = this.filterPedidosEmHistorico.page;
      await this.pedidosEmHistorico();
    },

    async nextPagePedidosEmHistorico() {
      this.filterPedidosEmHistorico.page += 1;
      this.pagePedidosEmHistorico = this.filterPedidosEmHistorico.page;
      await this.pedidosEmHistorico();
    },

    async handleRowClick(item) {
      const model = {
        filterPedidosEmHistorico: this.filterPedidosEmHistorico,
        filterOrdersPlaced: this.filterOrdersPlaced,
        filterPedidosEmAbertos: this.filterPedidosEmAbertos,
        pagePedidosEmAbertos: this.pagePedidosEmAbertos,
        pagePedidosEmHistorico: this.pagePedidosEmHistorico,
      };

      localStorage.setItem("ordersResaleFilters", JSON.stringify(model));
      localStorage.setItem("ordersResaleFiltersTab", this.activeTab);

      await this.$router.push({
        path: `/order-detailresale?id=` + item.id,
        params: item,
      });
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    formatDay(date) {
      return this.mesesAnos.find((x, index) => index === moment(date).month());
    },

    parse_date(date) {
      const momentDate = moment(date);
      return (
        momentDate.format("DD") /
        momentDate.format("MM") /
        momentDate.format("YYYY")
      );
    },

    toggleChangeDialog(item) {
      this.approveSelectedItem = item;
      this.ocurrentOrder = item;
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
    },

    exportOpenOrdersExcel(orders) {
      this.filterExportOrders = {
        OrderStatus: this.filterPedidosEmAbertos.OrderStatus,
        resaleId: this.filterPedidosEmAbertos.resaleId,
        dateStart: this.filterPedidosEmAbertos.dateStart,
        dateEnd: this.filterPedidosEmAbertos.dateEnd,
      }
      this.currentOrder = orders;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },
    exportExcel(orders) {
      this.filterExportOrders = {
        OrderStatus: this.filterPedidosEmHistorico.OrderStatus,
        resaleId: this.filterPedidosEmHistorico.resaleId,
        dateStart: this.filterPedidosEmHistorico.dateStart,
        dateEnd: this.filterPedidosEmHistorico.dateEnd,
      }
      this.currentOrder = orders;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },

    importExcel(order) {
      this.dialogKey = !this.dialogKey;
      this.importDialog = true;
    },

    openAbout(order) {
      this.ocurrentOrder = order;
      this.$router.push("/details-orders");
    },

    async getClientById(orders) {
      let email = "-";
      await this.apiService
        .get(`user/get-one?id=${orders.clientId}`)
        .then((response) => {
          if (response && response.email) {
            email = response.email;
          }
        });
      return email;
    },

    close() {
      this.$emit("close");
    },

    async generateExcel() {
      this.loading = true;

      let now = new Date();
      const filename =
        `Pedidos_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("order/excel", this.filterExportOrders)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          // this.$emit("close");
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: erro.body.message,
            trace: null,
          });
          this.loading = false;
        });
      this.loading = false;
    },
  },

  watch: {
    async activeTab() {
      await this.filterDates();
      if (this.activeTab == 0) {
        await this.pedidosEmAbertos();
      } else {
        await this.pedidosEmHistorico();
      }
    },
  },
};
</script>
